import React, { useState } from "react";
import { ModelCatalog } from "./model-catalog.jsx";

const key = (item) => `${item.provider}:${item.model}`;

export function ReadySolutionModelCatalog({ catalog, onRetry, onSave }) {
  const [editing, setEditing] = useState(false);
  const [selection, setSelection] = useState([]);
  const [revision, setRevision] = useState(0);
  const [filter, setFilter] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const candidates = [
    ...new Map(
      [...(catalog.availableModels || []), ...catalog.items].map((item) => [
        key(item),
        item,
      ]),
    ).values(),
  ].sort((a, b) => key(a).localeCompare(key(b)));
  const dirty =
    JSON.stringify([...selection].sort()) !==
    JSON.stringify((catalog.models || []).map(key).sort());
  const start = () => {
    setSelection((catalog.models || []).map(key));
    setRevision(catalog.revision);
    setEditing(true);
    setFilter("");
    setNotice("");
    setError("");
  };
  const save = async () => {
    setBusy(true);
    setError("");
    setNotice("");
    try {
      await onSave(
        revision,
        candidates
          .filter((item) => selection.includes(key(item)))
          .map(({ provider, model }) => ({ provider, model })),
      );
      setEditing(false);
      setNotice("Состав списка готовых решений сохранён.");
    } catch (failure) {
      setError(failure.message || "Не удалось сохранить список моделей.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="ready-solution-model-catalog">
      <p className="muted">
        Первоначальный состав скопирован из TripRoutes. Это самостоятельный
        список для готовых решений; каждый клиент управляет своим списком
        отдельно.
      </p>
      <p className="muted">
        Изменение состава списка применяется к выбору моделей при следующей
        публикации настроек решения.
      </p>
      {!editing && (
        <button
          type="button"
          className="button ghost"
          disabled={
            catalog.loading || Boolean(catalog.error) || !catalog.revision
          }
          onClick={start}
        >
          Изменить состав списка
        </button>
      )}
      {editing && (
        <fieldset disabled={busy}>
          <legend>Модели готовых решений</legend>
          <label>
            Найти модель
            <input
              type="search"
              value={filter}
              onChange={(event) => setFilter(event.target.value)}
              placeholder="Название модели или провайдер"
            />
          </label>
          <div className="ready-model-options">
            {candidates
              .filter((item) =>
                key(item).toLowerCase().includes(filter.trim().toLowerCase()),
              )
              .map((item) => (
                <label key={key(item)}>
                  <input
                    type="checkbox"
                    checked={selection.includes(key(item))}
                    onChange={(event) =>
                      setSelection((current) =>
                        event.target.checked
                          ? [...current, key(item)]
                          : current.filter((value) => value !== key(item)),
                      )
                    }
                  />
                  <span>
                    {item.model} · {item.provider}
                    {!item.currency && (
                      <small>
                        Действующего тарифа нет — удалите из списка.
                      </small>
                    )}
                  </span>
                </label>
              ))}
          </div>
          <div className="corplinks-actions">
            <button
              type="button"
              className="button primary"
              disabled={busy || !dirty}
              onClick={save}
            >
              {busy ? "Сохраняем…" : "Сохранить список"}
            </button>
            <button
              type="button"
              className="button ghost"
              disabled={busy}
              onClick={() => {
                setEditing(false);
                setError("");
              }}
            >
              Отмена
            </button>
          </div>
        </fieldset>
      )}
      {error && (
        <p className="inline-problem" role="alert">
          {error}
        </p>
      )}
      {notice && <p role="status">{notice}</p>}
      <ModelCatalog
        prices={catalog.items}
        loading={catalog.loading}
        error={catalog.error}
        onRetry={onRetry}
        productName="Готовые решения"
        embedded
      />
    </div>
  );
}
